'use strict';

/**
 * Initializes the Back to Top functionality for mobile devices only.
 * Shows a button after scrolling, and scrolls to top on click.
 */
function initBackToTop() {
    var $backToTopBtn = $('#backToTop');
    var isEnabled = false;

    if ($backToTopBtn.length === 0) return;

    /**
	 * Enables the scroll and click event handlers for back to top button.
	 */
    function enableBackToTop() {
        if (isEnabled) return;
        isEnabled = true;

        $(window).on('scroll.backToTop', function () {
            if ($(window).scrollTop() > 300) {
                $backToTopBtn.fadeIn();
            } else {
                $backToTopBtn.fadeOut();
            }
        });

        $backToTopBtn.on('click.backToTop', function () {
            $('html, body').animate({ scrollTop: 0 }, 600);
        });
    }

    /**
	 * Disables event handlers and hides the back to top button.
	 */
    function disableBackToTop() {
        if (!isEnabled) return;
        isEnabled = false;

        $(window).off('scroll.backToTop');
        $backToTopBtn.off('click.backToTop');
        $backToTopBtn.hide();
    }

    /**
	 * Checks screen width and toggles Back to Top functionality.
	 */
    function toggleBackToTop() {
        if (window.innerWidth <= 767) {
            enableBackToTop();
        } else {
            disableBackToTop();
        }
    }

    toggleBackToTop(); // Initial check
    $(window).on('resize', toggleBackToTop); // Responsive update
}

module.exports = {
    initBackToTop: initBackToTop,
};
